<template>
  <div>
  <div class="mainMenus" v-if="getLocaltypes()==1">
    <div class="Contentframe" >
        <div class="leftmenu">
          <LeftMenus  :styles="styles" :active="active" :infoID="$route.query.infoID"></LeftMenus>
    </div>
 
  <div class="rightContent"> 
     <iframe :src="imagepath+htmlURLs" id="outerHTML" class="outerHTMLCss" width='100%'  name="ifd"  ref="iframe2"   style="min-height:800px" scrolling="no" frameborder="0"  ></iframe> 

     </div>
 
  </div>
  
</div>
<div v-if="getLocaltypes()==2">
  <iframe :src="imagepath+htmlURLs" id="outerHTML" class="outerHTML2" width='100%'  name="ifd"  ref="iframe2" scrolling="no" frameborder="0"  ></iframe> 
</div>
  </div>
</template>

<script>
import LeftMenus from './../../LeftMenus.vue'
import {getLocaltype} from '../../../mainConfig/thu'

// import "@/components/work/until/text.js"
//  import LeftNavigation from '@/components/work/navigation/majorsetup/LeftNavigation.vue'


//     onMounted(()=>{
// //使用JavaScript监听iframe元素的load事件，然后根据iframe中document的高度来动态调整iframe窗口的高度。
//    var testFrame = document.getElementById('outerHTML');
//     testFrame.addEventListener('load', function() {
//         testFrame.height = getHeight(testFrame.contentDocument);
//     });
//     function getHeight(doc) {outerHTML
//         var body = doc.body,
//             html = doc.documentElement;

//         var height = Math.max( body.scrollHeight, body.offsetHeight,
//             html.clientHeight, html.scrollHeight, html.offsetHeight );
//         return height;
//     }
// })

export default {
  components:{LeftMenus},
  mounted(){

      var that = this
    const iframe = document.querySelector('#outerHTML')
    
    // 处理兼容行问题
    if (iframe.attachEvent) {
      iframe.attachEvent('onload', function () {
        // iframe加载完毕以后执行操作

      })
    } else {
      iframe.onload = function () {

        // iframe加载完毕以后执行操作iframe
        console.log('hhhiframe已加载完毕')
        iframe.style.height =
         that.$refs.iframe2.contentWindow.document.body.scrollHeight + 'px';
         let phoneWidth= document.documentElement.clientWidth
       let htmlWidth= that.$refs.iframe2.contentWindow.document.body.scrollWidth
       let zoomW=phoneWidth/htmlWidth
          iframe.style.width  = '100%'
          console.log('ddd',zoomW,that.getLocaltypes()==1)
          if(that.getLocaltypes()==2){
            iframe.style.zoom=zoomW
          }

      }
      
    }

  },
  //  components:{LeftNavigation},
  data(){
  return{
    htmlURLs:'',
    imagepath:'',
    visible: true,
    info:{},
    active:[],
    infoId:'',
    infoList:[],
    styles:[],
  }
},
created(){
  this.getHtmlpath() 
  //  this.reinitframe();
  
},
methods:{
  getLocaltypes(){
  return getLocaltype();
},
  getHtmlpath(){
    // window.setInterval("this.reinitframe",2000);
    this.imagepath=this.$imagepath
    this.active=this.$route.query.active
    this.styles=this.$route.query.styles
    this.htmlURLs=this.$route.query.htmlpath
    this.infoId=this.$route.query.infoID
    //  console.log(this.$imagepath+this.htmlURLs)
    //   this.axios.post("/info/getInfo?infoID="+this.$route.query.infoID)
    // .then(resp => { 
    //                   if(resp.data.status == 1) {      
    //                     this.info=resp.data.result[0]                                                
    //                                console.log(resp.data.result[0])   
    //                                this.infoList=resp.data.result[0]   
    //                             }else {
    //                                alert("拿取数据失败")                                 
    //                             }
    //                         })
    //                         .catch((err) => {
    //                            // alert("出错了")
    //                             console.log(err)
    //                         })     
  
  },
  
// selected(name){
//    this.active = name;
// },



reinitframe()
{
  var  iframe= window.document.getElementById("outerHTML");
  console.log(iframe)
  
        iframe.onload = function()
    
        {
      
          iframe.style.height = 
          iframe.contentWindow.document.body.scrollHeight + 'px';
           
  
         // set the width of the iframe as the 
         // width of the iframe content
         iframe.style.width  =  iframe.contentWindow.document.body.scrollWidth+'px';
              
        }

         console.log(iframe.style.width)

}


} //methods
} //scripts
</script>

<style scoped>
  .leftAside{
    position: fixed;
    width:30%;
   
  }
.outerHTMLCss{
  padding-left: 60px;
  width: 100%;
  padding-top: 20px;

  
}
.outerHTML2{
  /* padding-left: 60px; */
  width: 100%;
  padding-top: 20px;

  
}
.newsMain{
  width: 100%;
  height: 100%;
      display: block;
  
}

.Contentframe{
  width: 90%;
  margin: auto;
  display: flex;
 
}

.active {
    
    border-bottom: 4px solid #0065bd;
    /* border-left: 2px solid #e362d5;
    border-color: transparent transparent transparent #E362D5; */
    
 }

 .leftmenu1
 {
   padding-left:15px;
     background:rgb(196, 196, 233,0.6);
   color:black;
   margin-top: 40px;
   margin-right: 20px;
   height:400px;
   width:20%;
   padding: 20px;
   box-shadow: 0px 0px 2px #ededed;
 }
  .leftmenu
 {
   padding-left:15px;
     background:#0065bd;
   color:black;
   margin-top: 40px;
   margin-right: 20px;
   height:500px;
   width:20%;
   padding: 20px;
 }

 .mainMenus{
  width: 100%;
  min-width: 1200px;
  height: 100%;
  margin: auto;
  display: flex;
}
.mainMenus{
  padding-left: 0px;
}

 .firstmenu
 {
   font-weight: 500;
   font-size: 18px;
   line-height: 20px;
   padding-top: 10px;
    border-left: 8px solid #ffd04b;
    /* border-bottom: 1px solid #ecebeb; */
   
 }

 .firstsubMenu
 {
   width: 100%;
    height: 40px;
    line-height: 40px;
    color: #010544;
    padding: 0 10px;
    font-size: 18px;
    font-weight: 600;
    border-left: 6px solid #0065bd;
    /* border-bottom: 1px solid #ecebeb; */
}
 .firstsubMenu1
 {
   width: 100%;
    height: 0.52rem;
    line-height: 0.52rem;
    color: #010544;
    padding: 0 10px;
    font-size: 0.2rem;
    font-weight: 600;
    border-left: 0.08rem solid #e362d5;
    border-bottom: 1px solid #ecebeb;
}
 

  .submenu
 {
   font-weight: 400;
   font-size: 16px;
    margin-left: 10px;
    color: black;
    /* border-bottom: 2px solid #ecebeb */
   
 }
.rightContent{
  width: 80%;
  margin-left:50px;

}

.el-container{
  height: auto;
}



 .el-aside .leftmenu{
  position: fixed;

 }
  .router-link-active {     
   text-decoration: none;
   
 }
 
 a {
   text-decoration: none;

 }
</style>


// WEBPACK FOOTER //
// src/components/work/navigation/majorsetup/communications.vue